import http from "./HttpService";

const endpoint = process.env.VUE_APP_REWARD_CENTER_BASE_URL;


export const getTreasuryList = () => {
  return http.get(`/treasury/list`, {
    baseURL: endpoint,
  });
};

export const increaseTreasuryValue = (data) => {
  return http.post(`/treasury/increase`, data, {
    baseURL: endpoint,
  });
};

export const getCoinPrice = (coinName) => {
  return http.get(
    `https://public.eterex.com/api/assets/price/${coinName}/USDT`
  );
};

export const getCoinPrices = () => {
  return http.get(
    `https://public.eterex.com/api/assets/price/list`
  );
};

export const getUSDTPriceByToman = () => {
  return http.get("/Configs", {
    baseURL: process.env.VUE_APP_BASE_URL,
  });
};
